<div class="modal-header">
  <h4 class="modal-title" i18n>Pay balance</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label" i18n>Amount due</label>
        {{ abs(contact.balance) | currency: organization.currency }}
      </div>
      <div class="col-12">
        <label class="form-label" i18n>Payment card</label>
        <select class="form-select" formControlName="card">
          <option ngValue="new_card" i18n>New payment card</option>
          <option *ngFor="let card of contact.cards" [ngValue]="card.id">{{ card.number }} <ng-container
              i18n>expires</ng-container> {{ card.expire_month | number: '2.0-0' }}/{{ card.expire_year }}</option>
        </select>
      </div>
      
      <div *ngIf="this.form.controls.card.value == 'new_card'" class="col-12">
        <input type="checkbox" id="save-card" class="form-check-input" formControlName="saveCard">&nbsp;
        <label class="form-check-label" for="save-card" i18n>Save card for future purchases</label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="pay()" i18n>Make payment</button>
</div>